import styled from "@emotion/styled";
import Colors from "/styles/colors";
import { MACBOOK_PRO_MAX_WIDTH } from "/constants/vp-sizes";
export const StyledResponsiveBanner = styled.div`
  height: 240px;
  display: flex;
  background-color: ${Colors.riverstone};
  border-radius: 8px;

  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    text-align: left;

    height: 100%;

    padding-left: 50px;

    .title {
      font-size: 1.75rem;
      font-weight: 700;
      line-height: 38px;
    }

    .description {
      margin-top: 12px;
      font-size: 1rem;
      line-height: 30px;
    }
  }

  .image-wrapper {
    height: 100%;
    padding: 0 72px;

    .banner-image {
      border-radius: 0px 8px 8px 0px;
      height: 100%;
    }
  }

  &.iris {
    background-color: ${Colors["brand-iris"]};
    color: white;
  }

  &.mobile-banner {
    flex-direction: column;
    height: initial;

    .content-wrapper {
      padding: 24px 40px 0 40px;

      .title {
        font-size: 1.125rem;
        line-height: 24px;
        text-align: center;
      }

      .description {
        display: none;
      }
    }

    .image-wrapper {
      padding: 0;
      display: flex;
      justify-content: center;

      .banner-image {
        width: 100%;
      }
    }
  }

  @media (max-width: ${MACBOOK_PRO_MAX_WIDTH}) {
    &:not(.mobile-banner) {
      .content-wrapper {
        padding-left: 25px;
      }

      .image-wrapper {
        padding: 0 16px;
      }
    }
  }
`;
